import { memo } from 'react'

import IMask from 'imask'

import { SecuredInput } from './SecuredInput'
import { BaseInputProps } from './props'

export const EINInput = memo((props: BaseInputProps) => {
  const mask = IMask.createMask({
    mask: '00-0000000'
  })
  return <SecuredInput {...props} mask={mask} />
})
